module.exports = __webpack_public_path__ + "static/media/cases_3d_06b.d5182005.jpg";